import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetailLoadingService {

  private loadingSubject$ = new BehaviorSubject<boolean>(true);
  public isLoading$: Observable<boolean> = this.loadingSubject$.asObservable();

  constructor() { }

  // Start loading
  startLoading(): void {
    this.loadingSubject$.next(true);
  }

  // Stop loading
  stopLoading(): void {
    this.loadingSubject$.next(false);
  }

  // Get current loading state
  getLoadingState(): boolean {
    return this.loadingSubject$.value;
  }
}